<template>
  <!-- 0 0 24 24-->
  <path
    d="M17.8053 4.22927C18.3718 3.2291 17.6344 1.99998 16.468 2L9.96131 2.0001C9.25438 2.00012 8.63953 2.47527 8.47408 3.14945L6.01463 13.1708C5.92324 13.5431 6.27501 13.874 6.65047 13.7688L8.54148 13.2388C8.9164 13.1337 9.26793 13.4635 9.17762 13.8356L7.34597 21.3816C7.22046 21.8987 7.89504 22.2255 8.23733 21.8134L17.0795 11.1688C17.3893 10.7959 17.0363 10.251 16.5605 10.3676L15.1089 10.7236C14.6761 10.8297 14.3228 10.378 14.5395 9.99544L17.8053 4.22927Z"
    fill="currentColor"
  />
</template>
